import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  cookies = '';

  constructor(
    @Optional() @Inject(REQUEST) private request: Request<any>,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    if (isPlatformServer(platformId) && this.request && this.request.headers && this.request.headers.cookie) {
      this.cookies = this.request.headers.cookie;
    } else if (isPlatformBrowser(platformId)) {
      this.cookies = this.document.cookie;
    }
  }

  get(key: string): any {
    if (this.cookies) {
      const keyName = key + '=';
      const ca = this.cookies.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(keyName) === 0) {
          return c.substring(keyName.length, c.length);
        }
      }
    }
    return null;
  }

  set(key: string, value: any, expires?: Date): void {
    if (isPlatformBrowser(this.platformId)) {
      this.document.cookie =
        key + '=' + value + ';path=/' + (expires ? ';expires=' + new Date(expires.valueOf() * 1000).toUTCString() : '');
      this.cookies = this.document.cookie;
    }
  }

  exists(key: string): boolean {
    return this.get(key) !== null;
  }

  delete(key: string): void {
    if (isPlatformBrowser(this.platformId) && this.exists(key)) {
      this.document.cookie = key + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
      this.cookies = document.cookie;
    }
  }
}
